import styled from "styled-components";

export const  AuthWriterCreateStyle = styled.div`
    .auth-writer-container{
        .form-wrapper{
            padding-bottom: ${props => 2*props.theme.space.margin}px;
        }
    }
`
